export type DesktopAudioFormat = { encoding: 's16le'; sampleRate: number; channels: number };
export type DesktopReminderInfo = {
  enabled: boolean;
  running: boolean;
  capability: 'heuristic' | 'unavailable';
  pending?: boolean;
};
export type DesktopAudioStart =
  | { ok: true; id: string; method: 'pcm' | 'loopback'; format?: DesktopAudioFormat }
  | { ok: false; error: string };
export interface DesktopRecordingBridge {
  getInfo(): Promise<{
    recording?: { systemAudio: boolean; method: 'pcm' | 'loopback' | null };
    meetingReminders?: DesktopReminderInfo;
  }>;
  setMeetingRemindersEnabled?(enabled: boolean): Promise<DesktopReminderInfo>;
  dismissMeetingReminder?(): Promise<void>;
  onMeetingReminder?(listener: (event: { kind: 'suspected-meeting' }) => void): () => void;
  startSystemAudio(): Promise<DesktopAudioStart>;
  stopSystemAudio(id: string): Promise<unknown>;
  onSystemAudioFrame(listener: (frame: { id: string; data: ArrayBuffer }) => void): () => void;
  onSystemAudioState(
    listener: (state: { id: string; state: string; error?: string }) => void,
  ): () => void;
}

/** Old desktop releases remain usable as microphone-only clients. */
export function desktopRecordingBridge(): DesktopRecordingBridge | null {
  const bridge = typeof window === 'undefined' ? undefined : window.ponevaDesktop;
  return bridge &&
    [
      'getInfo',
      'startSystemAudio',
      'stopSystemAudio',
      'onSystemAudioFrame',
      'onSystemAudioState',
    ].every((name) => typeof (bridge as unknown as Record<string, unknown>)[name] === 'function')
    ? (bridge as DesktopRecordingBridge)
    : null;
}
